import React from 'react';
import {Heading, Box, VStack, StatusBar, Text, Center} from 'native-base';
import {StyleSheet} from 'react-native';
import {message} from '../../../utils/messages';
import {SuccessIcon} from './../../icons';

interface Props {
  title: string;
  summary: string;
  children: JSX.Element[] | JSX.Element;
}

const baseColor = 'white';
const colors = {
  title: '#05375a',
  summary: '#05375a',
};

const SuccessTemplate = (props: Props) => {
  const {children, title, summary} = props;

  return (
    <>
      <StatusBar
        translucent
        backgroundColor="transparent"
        barStyle="dark-content"
      />
      <Box flex="1" backgroundColor={baseColor}>
        <VStack style={styles.messageBox} px={8} py="60%" flex={1}>
          <Center>
            <SuccessIcon />
            <Heading color={colors.title} mt="5">
              {message(title)}
            </Heading>
            <Text
              color="gray.500"
              textAlign="center"
              fontSize="md"
              mx="3"
              mt="2">
              {message(summary)}
            </Text>
          </Center>
        </VStack>
        <Box
          width="100%"
          position="absolute"
          bottom="0"
          safeArea
          mb="5"
          pb="10"
          px="8">
          {children}
        </Box>
      </Box>
    </>
  );
};

const styles = StyleSheet.create({
  messageBox: {},
});

export default SuccessTemplate;
